module.exports = __webpack_public_path__ + "img/recharge-progress-3.e10a8a52.png";